/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgDisclosure } from '../../models/esg-disclosure';
import { EsgDisclosureFieldsFilter } from '../../models/esg-disclosure-fields-filter';
import { EsgFramework } from '../../models/esg-framework';

export interface DisclosuresByProfileByFrameworkByYearList$Params {
  profileId: number;
  framework: EsgFramework;
  year: number;
  includeFields?: Array<EsgDisclosureFieldsFilter>;
}

export function disclosuresByProfileByFrameworkByYearList(http: HttpClient, rootUrl: string, params: DisclosuresByProfileByFrameworkByYearList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EsgDisclosure>>> {
  const rb = new RequestBuilder(rootUrl, disclosuresByProfileByFrameworkByYearList.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('framework', params.framework, {});
    rb.path('year', params.year, {});
    rb.query('includeFields', params.includeFields, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EsgDisclosure>>;
    })
  );
}

disclosuresByProfileByFrameworkByYearList.PATH = '/esg/profile/{profileId}/esg/framework/{framework}/year/{year}';
